"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Score = void 0;
const Block_1 = require("./Block");
const pixi_js_1 = require("pixi.js");
const Global_1 = require("../Global");
const gsap_1 = require("gsap");
const i18next_1 = __importDefault(require("i18next"));
class Score extends Block_1.Block {
    constructor(app, icon) {
        super(app);
        this.icon = icon;
        this.text = new pixi_js_1.Text('0', Block_1.Block.textStyle(32, false));
        this.text.anchor.set(1, 0.5);
        this.icon.anchor.set(0, 0.5);
        this.addChild(this.text, this.icon);
        this.layout();
    }
    update(by, item, label, icon = null) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.series(() => __awaiter(this, void 0, void 0, function* () {
                const factor = Math.min(0.2, 3 / (Math.abs(by) || 1));
                for (let i = 0; i < Math.abs(by); i++) {
                    yield this.bumpNumber(item, (by < 0) ? -1 : 1, factor, icon);
                }
                if (by) {
                    const text = new pixi_js_1.Text((by < 0 ? '' : '+') + by + ' ' + i18next_1.default.t(label), Block_1.Block.textStyle(18));
                    text.anchor.set(1, 0);
                    text.position.set(this.width, text.height + (0, Global_1.px)(15));
                    text.alpha = 0;
                    this.addChild(text);
                    yield this.promisedTimeline(gsap_1.gsap.timeline().to(text, {
                        pixi: {
                            alpha: 1.0,
                            positionY: (0, Global_1.px)(15)
                        },
                        duration: 0.5
                    }).to(text, {
                        pixi: {
                            alpha: 0,
                        },
                        duration: 0.2,
                        delay: 2
                    }));
                    text.destroy();
                }
            }));
        });
    }
    bumpNumber(item, amount = 1, time = 0.2, icon = null) {
        return __awaiter(this, void 0, void 0, function* () {
            const cur = parseInt(item.text || '0');
            const tm = gsap_1.gsap.timeline();
            if (icon) {
                icon.anchor.set(0, 0.5);
                icon.position.set(0, icon.height * 1.5);
                icon.alpha = 0;
                const step = {
                    pixi: {
                        alpha: 1,
                        positionY: 0
                    },
                    duration: time,
                    ease: 'none',
                    onComplete: () => {
                        icon.alpha = 0;
                    }
                };
                if (amount < 0) {
                    tm.from(icon, step);
                }
                else {
                    tm.to(icon, step);
                }
            }
            yield this.promisedTimeline(tm
                .to(item, {
                pixi: {
                    scale: 1.8
                },
                duration: time / 2,
                ease: 'power2.in',
            }, icon ? '-=40%' : null).to(item, {
                onStart: () => {
                    item.text = cur + amount;
                },
                pixi: {
                    scale: 1
                },
                duration: time / 2,
                ease: 'power2.out'
            }));
        });
    }
    set(total) {
        this.text.text = total === null || total === void 0 ? void 0 : total.toString();
        this.layout();
    }
    layout() {
        super.layout();
        const pad = (0, Global_1.px)(4);
        this.text.style.fontSize = (0, Global_1.px)(this.overSmallSize ? 28 : 26);
        this.text.position.set(this.text.width, 0);
        this.icon.position.set(this.text.width + pad, (0, Global_1.px)(-2));
    }
}
exports.Score = Score;
